<template>
	<div class="documents-card" @click="$router.push('/Documents')">
		<div class="documents-card-top">
			<img :src="require('@/assets/document.png')" class="documents-card-icon" alt="Documents" />
			<div class="documents-card-text">
				<p class="documents-card-title">My Documents</p>
				<p class="documents-card-subtitle" v-if="documentCount > 0">You've added <strong>{{ documentCount }} {{ documentCount === 1 ? 'document' : 'documents' }}</strong> across <strong>{{ categoryCount }} {{ categoryCount === 1 ? 'category' : 'categories' }}</strong>.</p>
				<p class="documents-card-subtitle" v-else>Send documents via WhatsApp for automatic analysis.</p>
			</div>
			<img :src="require('@/assets/arrow-right.png')" class="documents-card-arrow" />
		</div>
		<div class="documents-card-bottom">
			<div class="documents-card-whatsapp-icon">
				<img :src="require('@/assets/whatsapp.png')" alt="WhatsApp" />
			</div>
			<p class="documents-card-bottom-text">Powered by your WhatsApp AI Assistant.</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'DocumentsInfoPanel',
	props: {
		documentCount: { type: Number, default: 0 },
		categoryCount: { type: Number, default: 1 }
	}
}
</script>

<style scoped>
.documents-card {
	border-radius: 8px;
	overflow: hidden;
	box-shadow: 0px 4px 8px 0px rgba(51, 40, 71, 0.05);
}

.documents-card-top {
	background: var(--background-color);
	padding: 20px;
	display: flex;
	gap: 12px;
	align-items: center;
}

.documents-card-icon {
	width: 40px;
	height: 40px;
	flex-shrink: 0;
}

.documents-card-text {
	flex: 1;
	min-width: 0;
	padding-right: 24px;
}

.documents-card-title {
	font-size: 15px;
	font-weight: bold;
	margin: 0;
	color: var(--brand-purple);
}

.documents-card-subtitle {
	font-size: 13px;
	line-height: 16px;
	margin: 0;
	color: var(--brand-purple);
}

.documents-card-arrow {
	width: 16px;
	height: 12px;
	flex-shrink: 0;
}

.documents-card-bottom {
	background: #E0EBE3;
	padding: 8px 12px;
	display: flex;
	gap: 8px;
	align-items: center;
}

.documents-card-whatsapp-icon {
	width: 20px;
	height: 20px;
	border-radius: 999px;
	background: #24CA3C;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}

.documents-card-whatsapp-icon img {
	width: 12px;
	height: 12px;
}

.documents-card-bottom-text {
	font-size: 11px;
	font-weight: bold;
	line-height: 12px;
	margin: 0;
	color: var(--brand-purple);
}
</style>
